module.exports = __webpack_public_path__ + "img/dy2.22a13a55.png";